import Entity from './entity'
export default class AwardWinUser extends Entity<number>{
}